import React, { useState, useRef } from 'react';
import { useHistory } from "react-router-dom";
import {
    Box,
    Button,
    Typography,
    makeStyles,
    MenuItem,
    Select,
    Container,
    FormControl,
    Stepper,
    Step,
    StepLabel,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import UploadDetailsSavedDialog from '../../ModalPopups/UploadDetailsSavedDialog';
import axios from 'axios';
import { useApiBaseUrl } from '../../../../common/CommonMethods/CommonMethods';
import { appUrl } from '../../../../../../../utils/config';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    stepperHeader: {
        padding: "32px 0",
        textAlign: "center",
        backgroundColor: "#F5F9FF",
        position: "relative",
    },
    heading: {
        fontWeight: 600,
        fontSize: 38,
        lineHeight: "100%",
        marginBottom: 20,
    },
    subheading: {
        fontWeight: 400,
        fontSize: 24,
        lineHeight: "100%",
    },
    closePageAction: {
        position: "absolute",
        top: 20,
        right: 20,
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        fontWeight: "bold",
        color: "#000",
        "& svg": {
            marginLeft: 4,
            color: "red",
        },
    },
    uploadBox: {
        width: "100%",
        marginTop: "2em",
        border: "1px solid black",
        backgroundColor: "#f5f5f5",
        padding: "2em 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        minHeight: 60,
    },
    uploadText: {
        marginLeft: "auto",
        textAlign: "center",
        flex: 1,
        fontSize: 16,
    },
    uploadIcon: {
        fontSize: "40px",
        marginLeft: "auto",
        marginRight: "20px",
        color: "#333",
    },
    file: {
        marginTop: "2em",
        display: "flex",
        flexDirection: "column",
        gap: "1em",
        alignItems: "flex-start",
    },
    link: {
        color: "blue",
        textDecoration: "underline",
    },
    linkBox: {
        cursor: "pointer",
        display: "flex",
        gap: "0.5em",
    },
    bold: {
        fontWeight: 500,
    },
    criteria: {
        maxWidth: "500px",
    },
    uploadBtn: {
        backgroundColor: "#ec6535",
        color: "white",
        textTransform: "none",
        borderRadius: "50px",
        margin: "1em auto",
        padding: "5px 30px",
        "&:hover": {
            backgroundColor: "#ec6535",
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#ec6535",
    },
    /* ---- BCM-234: two-file upload layout ---- */
    fileGrid: {
        display: "flex",
        gap: "1.5rem",
        width: "100%",
        marginBottom: "1.5rem",
        flexWrap: "wrap",
    },
    fileCard: {
        flex: "1 1 320px",
        minWidth: 280,
        border: "1px dashed #c8ccd4",
        borderRadius: 8,
        padding: "1.5rem 1.25rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0.9rem",
        background: "#fff",
        transition: "background 0.15s, border-color 0.15s",
    },
    // Filled state: solid green tint, matching the deck.
    fileCardFilled: {
        border: "1px solid #b7dfc4",
        background: "#f4fbf6",
    },
    // BCM-234: only one file may be uploaded per run, so the other card is
    // dimmed while a file is selected (its button is disabled too).
    fileCardDisabled: {
        background: "#f7f8fa",
        borderColor: "#e3e5e9",
        opacity: 0.6,
    },
    fileCardHint: {
        fontSize: "0.8125rem",
        color: "#6b7280",
        textAlign: "center",
    },
    fileCardTitle: {
        fontSize: "1rem",
        fontWeight: 700,
        color: "#1a1a1a",
    },
    chooseFileBtn: {
        textTransform: "none",
        fontSize: "0.875rem",
        border: "1px solid #c8ccd4",
        borderRadius: 4,
        padding: "6px 18px",
        background: "#fff",
        boxShadow: "none",
        "&:hover": { background: "#f5f6f8", boxShadow: "none" },
    },
    chosenRow: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        flexWrap: "wrap",
        justifyContent: "center",
        fontSize: "0.875rem",
    },
    chosenCheck: {
        color: "#1e7e34",
        fontWeight: 700,
    },
    chosenName: {
        color: "#1a1a1a",
        maxWidth: 220,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    chosenSize: {
        color: "#6b7280",
        fontSize: "0.8125rem",
    },
    removeLink: {
        color: "#c05621",
        textDecoration: "underline",
        cursor: "pointer",
        fontSize: "0.875rem",
        background: "none",
        border: "none",
        padding: 0,
        fontFamily: "inherit",
    },
    criteriaTitle: {
        fontWeight: 700,
        fontSize: "0.9375rem",
        color: "#1a1a1a",
        marginBottom: "0.35rem",
    },
    criteriaLine: {
        fontSize: "0.875rem",
        color: "#3c4043",
        lineHeight: 1.7,
    },
    sampleLink: {
        color: "#1976d2",
        fontSize: "0.875rem",
        textDecoration: "underline",
    },
    filePreview: {
        marginLeft: theme.spacing(4),
        marginBottom: theme.spacing(2),
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 8,
    },
    fileName: {
        color: "#2592f9",
        borderBottom: "2px solid #2592f9",
        paddingBottom: 2,
        cursor: "pointer",
    },
    fileSelect: {
        marginLeft: theme.spacing(4),
        marginBottom: theme.spacing(2),
        fontWeight: "bold"
    },
    uploadButton: {
        display: "flex",
        justifyContent: "center",
        margin: theme.spacing(4, 0),
    },
    uploadButtonStyle: {
        backgroundColor: '#ec6535',
        // width: "170px", // Removed fixed width
        color: '#fff',
        borderRadius: 20,
        padding: '6px 24px',
        textTransform: 'none',
        display: 'flex',
        alignItems: 'center',
        fontSize: "16px",
        gap: 8,
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: '#c6532b',
        },
    },
    validationSummary: {
        padding: "2em",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        margin: "2em 0",
    },
    summaryItem: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1em",
        margin: "0.5em 0",
        borderRadius: "4px",
        backgroundColor: "white",
    },
    validCount: {
        color: "#4caf50",
        fontWeight: "bold",
    },
    invalidCount: {
        color: "#f44336",
        fontWeight: "bold",
    },
    totalCount: {
        color: "#2196f3",
        fontWeight: "bold",
    },
    container: {
        textAlign: "center",
        padding: "1rem"
    },
    itemGrid: {
        border: "2px solid #707070",
        padding: "1rem",
    },
    number: {
        fontSize: "2.4rem",
        fontWeight: 500
    },
    totalRecordsBox: {
        border: "2px solid #707070",
        padding: "1rem",
    },
    validRecordsBox: {
        border: "2px solid #707070",
        padding: "1rem",
    },
    invalidRecordsBox: {
        border: "2px solid #707070",
        padding: "1rem",
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: theme.spacing(3),
        width: "100%",
    },
    reUploadButton: {
        marginRight: "auto",
        alignSelf: "flex-start",
        textDecoration: "underline",
        cursor: "pointer",
        textTransform: "none",
    },
}));

// BCM-234: two files are uploaded together now (master data + storage
// locations), so the step label is plural.
const getSteps = () => ["Upload files", "Validation summary"];

const transformValidRecordsForCorda = (validRecords, regionCode) => {
    return validRecords.map(record => ({
        productDetails: {
            facilityTypeName:record["Manufacturing Facility Type"] || "",
            drugTypeName:record["Product Modality"] || "",
            productTypeName:record["Product Type"] || "",
            productCode: record["BMS Product Code"] || "",
            productDescription: record["BMS Product Description"] || "",
            brand: record["Product Brand"] || "",
            status: record["Status"] || "Active",
            supplyTypeID: record["supplyTypeID"] || 0,
            facilityTypeID: record["facilityTypeID"] || 0,
            drugTypeID: record["drugTypeID"] || 0,
            vendorMosymphonyID: record["vendorMosymphonyID"] || 0,
            // pendingConfiguration: true,
            vendorPlant: record["vendorPlant"] || "",
            vendorName: record["vendorName"] || "",
            cmoProductCode: record["CMO Product Code"] || "",
            cmoProductDescription: record["CMO Product Description"] || "",
            cmoWIPProductCode: record["WIP Product"] || "",
            aslNumber: record["ASL Number"] || "",
            defaultASLNumber: record["Default ASL Number"] || "",
            CMOIDFromSponsorERP: record["CMO ID in BMS SAP System"] || "",
            shipmentRequired: record["Shipment Required"],
            // sponsorCQAApprovalReq lives on productDetails now (per BCM-393), not
            // processFlowConfiguration - moved out of that block below.
            sponsorCQAApprovalReq: String(record["QA Check Required (Yes or No)"] ?? "").trim().toLowerCase() === "yes",
            // BCM-234: product-level receivingStorageLocationIDsFromSponsorERP is
            // no longer persisted. Storage locations are derived from the plant's
            // network-level Plant-SLoc associations, so the FE does not forward
            // this column to Corda even if it is still present in older templates.
	        receivingPlantIDFromSponsorERP:record["BMS Product Receiving Plant IDs"] || "",
	        sponsorUOM:record["BMS UoM"] || "",
	        cmoUOM :record["CMO UoM"] || "",
            productTypeID:record["productTypeID"] || 0,
            regionCode: record["Region Code"] || "",
	        subContractingPOs : record["Sub-Contracting POs"],
        },
        materialDetails: {
            productMaterialsList: record["BMS Material Code"] ? [{
                bo_material_code: record["BMS Material Code"] || "",
                material_description: record["BMS Material Description"] || "",
                cmo_material_code: record["CMO Material Code"] || "",
                cmo_material_description: record["CMO Material Description"] || "",
                material_type_id:record["materialTypeID"] || 0,
                bo_material_UOM: record["BMS Material UoM"] || "",
                cmo_material_UOM: record["CMO Material UoM"] || "",
                material_brand: record["Material Brand"] || "",
             materialStorageLocationIDsFromSponsorERP:record["BMS Material Storage Location IDs"] || "",
            //  sponsorSupplyingMaterial: record["BMS Supplying Material"].toLowerCase() === "yes" ? true : false,
                  
        }] : []
        },
    }));
};

const UploadProductDetails = () => {
    const history = useHistory();
    const classes = useStyles();
    const [file, setFile] = useState(null);
    // BCM-234: optional second file. Rules from the deck (slide 9):
    //   • new product           → BOTH files required
    //   • existing product      → master data alone is fine
    //   • add storage locations → storage-location file alone is fine
    // The FE cannot tell new-vs-existing before validation, so it accepts any
    // non-empty combination and lets step 2 surface the backend's verdict
    // (e.g. "storage location not found for CMO-Product combination").
    const [slocFile, setSlocFile] = useState(null);
    const [fileType, setFileType] = useState('xlsx');
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [hasUploadedSuccessfully, setHasUploadedSuccessfully] = useState(false);
    const [uploadErrors, setUploadErrors] = useState([]);
    const [invalidRecords, setInvalidRecords] = useState([]);
    const [apiMessage, setApiMessage] = useState("");
    const [error, setError] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const [validationData, setValidationData] = useState(null);
    // BCM-234: the Storage Location file is a SEPARATE middleware pipeline from
    // Master Data (its own upload + submit endpoints), so its validation result
    // is tracked independently and merged into the summary below.
    //   Master Data     -> /uploadProductDetails         -> /productDetailsToCorda
    //   Storage Location -> /uploadProductPlantSLocMapping -> /updateProductPlantSLocMapping
    const [slocValidation, setSlocValidation] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const fileInputRef = useRef();
    const slocInputRef = useRef();
    const API_BASE_URL = useApiBaseUrl(appUrl);
    const steps = getSteps();

    const isExcel = (name) =>
        typeof name === 'string' && (name.endsWith('.xlsx') || name.endsWith('.xls'));

    const clearMessages = () => {
        setUploadErrors([]);
        setInvalidRecords([]);
        setApiMessage("");
        setError(null);
    };

    // BCM-234: storage-location file picker (second box in the deck's layout).
    const handleSlocFileChange = (e) => {
        // BCM-234: one file per upload — the button is disabled in this state,
        // this guard covers any other path into the handler.
        if (file) {
            e.target.value = "";
            return;
        }
        const selected = e.target.files[0];
        if (selected && isExcel(selected.name)) {
            setSlocFile(selected);
            clearMessages();
        } else if (selected) {
            alert('Please upload a .xlsx or .xls file');
        }
        e.target.value = "";
    };

    const handleRemoveSlocFile = () => {
        if (isUploading) return;
        setSlocFile(null);
        clearMessages();
        if (slocInputRef.current) slocInputRef.current.value = "";
    };

    const handleFileChange = (e) => {
        // BCM-234: one file per upload (see handleSlocFileChange).
        if (slocFile) {
            e.target.value = "";
            return;
        }
        const selectedFile = e.target.files[0];
        if (selectedFile && selectedFile.name.endsWith('.xlsx')) {
            setFile(selectedFile);
            setUploadErrors([]);
            setInvalidRecords([]);
            setApiMessage("");
            setError(null);
        } else {
            alert('Please upload a .xlsx file');
        }
        e.target.value = "";
    };

    const handleDrop = (e) => {
        e.preventDefault();
        // BCM-234: one file per upload — drag-and-drop must respect it too.
        if (slocFile) return;
        const droppedFile = e.dataTransfer.files[0];
        if (droppedFile && droppedFile.name.endsWith('.xlsx')) {
            setFile(droppedFile);
            setUploadErrors([]);
            setInvalidRecords([]);
            setApiMessage("");
            setError(null);
        } else {
            alert('Please upload a .xlsx file');
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleRemoveFile = () => {
        if (isUploading) return;
        setFile(null);
        setUploadErrors([]);
        setInvalidRecords([]);
        setApiMessage("");
        setError(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const getAcceptAttribute = (type) => {
        return ".xlsx, .xls";
    };

    const handleNext = () => setActiveStep((prev) => prev + 1);
    const handleBack = () => {
        setActiveStep((prev) => prev - 1);
        setHasUploadedSuccessfully(false);
        setValidationData(null);
        setSlocValidation(null);
    };

    const handleUpload = async () => {
        // BCM-234: either file on its own is a valid submission (see the slocFile
        // state comment) — so upload is allowed as soon as at least one is chosen.
        if ((file || slocFile) && !isUploading) {
            setIsUploading(true);
            setUploadErrors([]);
            setInvalidRecords([]);
            setApiMessage("");
            setError(null);
            try {
                let masterData = null;
                let slocData = null;

                // --- Master Data pipeline (unchanged contract: field 'files') ---
                if (file) {
                    const masterForm = new FormData();
                    masterForm.append('files', file);
                    const masterResp = await axios.post(
                        `${API_BASE_URL}/uploadProductDetails`,
                        masterForm
                    );
                    masterData = masterResp.data;
                }

                // --- BCM-234 Storage Location pipeline (separate endpoint) ---
                // The middleware expects the workbook under the SAME 'files' field
                // (see validateProductPlantSLocMappingFile: req.files.files).
                if (slocFile) {
                    const slocForm = new FormData();
                    slocForm.append('files', slocFile);
                    const slocResp = await axios.post(
                        `${API_BASE_URL}/uploadProductPlantSLocMapping`,
                        slocForm
                    );
                    slocData = slocResp.data;
                }

                setIsUploading(false);

                // A hard failure (status:false + a description/message) from either
                // call is a file-level error, not per-row — surface it and stay on
                // step 0 so the user can re-pick the file.
                const masterHardError =
                    masterData && masterData.status === false && masterData.errorDescription;
                const slocHardError =
                    slocData && slocData.status === false &&
                    (slocData.errorDescription || slocData.errorMessage);

                if (masterHardError || slocHardError) {
                    setUploadErrors([
                        masterHardError ? masterData.errorDescription : null,
                        slocHardError ? (slocData.errorDescription || slocData.errorMessage) : null,
                    ].filter(Boolean));
                    setHasUploadedSuccessfully(false);
                    setUploadSuccess(false);
                    return;
                }

                // BCM-897: "a brand-new product needs a storage location" — each
                // master-data row is independently tagged isNewProduct by the
                // backend (it never sees the Storage Location file). The FE is
                // the only place that holds BOTH independent validation results,
                // so the actual cross-check — does a matching row exist in the
                // Storage Location upload? — happens here, not on either server
                // call. A new product with no match gets reclassified from valid
                // to invalid before the summary/submit step ever sees it.
                const recordKey = (r) =>
                    `${String(r?.['CMO ID in BMS SAP System'] ?? '').trim()}|${String(r?.['BMS Product Code'] ?? '').trim()}`;
                const slocKeys = new Set((slocData?.validRecords || []).map(recordKey));

                const masterValidRecords = masterData?.validRecords || [];
                const keptValid = [];
                const slocMissingInvalid = [];
                masterValidRecords.forEach((record) => {
                    if (record.isNewProduct && !slocKeys.has(recordKey(record))) {
                        slocMissingInvalid.push({
                            row: record.__uploadRowNumber,
                            errors: [
                                `Storage location not found for CMO-Product combination ${record['CMO ID in BMS SAP System']}-${record['BMS Product Code']}.`,
                            ],
                            record,
                        });
                    } else {
                        keptValid.push(record);
                    }
                });

                const combinedInvalidRecords = [
                    ...(masterData?.invalidRecords || []),
                    ...slocMissingInvalid,
                ];

                // Master invalids keep the existing {row, errors[]} rendering.
                setInvalidRecords(combinedInvalidRecords);
                setApiMessage("");
                setHasUploadedSuccessfully(false);
                setValidationData(
                    masterData
                        ? {
                              ...masterData,
                              regionCode: masterData.regionCode,
                              validRecords: keptValid,
                              validRecordsCount: keptValid.length,
                              invalidRecords: combinedInvalidRecords,
                              invalidRecordsCount: combinedInvalidRecords.length,
                          }
                        : null
                );
                setSlocValidation(slocData || null);
                handleNext();
            } catch (error) {
                setIsUploading(false);
                setInvalidRecords([]);
                setApiMessage("");
                const desc =
                    error?.response?.data?.errorDescription ||
                    error?.response?.data?.errorMessage;
                setUploadErrors([desc || 'An error occurred while uploading. Please try again.']);
            }
        }
    };

    const handleSubmitValidRecords = async () => {
        const masterValid = validationData?.validRecords || [];
        const slocValid = slocValidation?.validRecords || [];

        if ((masterValid.length === 0 && slocValid.length === 0) || isSubmitting) return;

        setIsSubmitting(true);
        setError(null);
        try {
            // 1) Master Data FIRST — creating/updating the product is what makes it
            //    resolvable for the Storage Location mapping (the SLoc validation
            //    resolves collabrixProductID from product_details, so the product
            //    must exist before its plant→SLoc mapping is submitted).
            if (masterValid.length > 0) {
                const cordaRequest = {
                    products: transformValidRecordsForCorda(masterValid, validationData.regionCode),
                };
                const response = await axios.post(`${API_BASE_URL}/productDetailsToCorda`, cordaRequest);
                if (!response.data.status) {
                    setError(response.data.errorDescription || "Product submission failed.");
                    setIsSubmitting(false);
                    return;
                }
            }

            // 2) Storage Location mapping — validRecords are passed straight through;
            //    the upload response already carries the exact fields this endpoint
            //    consumes (collabrixProductID, vendorMosymphonyID, plant, SLoc).
            if (slocValid.length > 0) {
                const slocResponse = await axios.post(
                    `${API_BASE_URL}/updateProductPlantSLocMapping`,
                    { validRecords: slocValid }
                );
                if (!slocResponse.data.status) {
                    setError(
                        slocResponse.data.errorMessage ||
                        slocResponse.data.errorDescription ||
                        "Storage location submission failed."
                    );
                    setIsSubmitting(false);
                    return;
                }
            }

            setUploadSuccess(true);
            setHasUploadedSuccessfully(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorDescription ||
                error?.response?.data?.errorMessage ||
                "An error occurred during submission.";
            setError(errMsg);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCloseDialog = () => {
        setUploadSuccess(false);
        setFile(null);
        setFileType('xlsx');
        setIsUploading(false);
        setHasUploadedSuccessfully(false);
        setUploadErrors([]);
        setInvalidRecords([]);
        setApiMessage("");
        setError(null);
        setActiveStep(0);
        setValidationData(null);
        setSlocValidation(null);
        setSlocFile(null);
        setIsSubmitting(false);
        history.push(`/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/products`)
    };

    const handleGoBack = () => {
        history.goBack()
    };

    const displayError = (
        <Container
            style={{
                width: "100%",
                border: "2px solid red",
                backgroundColor: "#ffeaea",
                padding: "0.8rem",
                marginBottom: "1.5em",
                textAlign: "center",
                fontSize: "0.875rem",
            }}
        >
            <Typography variant="body2">{error}</Typography>
        </Container>
    );

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <Container>
                        {error && displayError}
                        {/* Show upload errors and invalid records below the upload button */}
                            {uploadErrors.length > 0 && (
                                <Box mt={2} style={{ width: '100%' }}>
                                    {uploadErrors.map((err, idx) => (
                                        <Container
                                            key={idx}
                                            style={{
                                                width: "100%",
                                                border: "2px solid red",
                                                backgroundColor: "#ffeaea",
                                                padding: "0.8rem",
                                                marginBottom: "0.5em",
                                                textAlign: "center",
                                                fontSize: "0.875rem",
                                            }}
                                        >
                                            <Typography variant="body2">{err}</Typography>
                                        </Container>
                                    ))}
                                </Box>
                            )}
                            {invalidRecords.length > 0 && (
                                <Box mt={2} style={{ width: '100%' }}>
                                    <Container
                                        style={{
                                            width: "100%",
                                            border: "2px solid red",
                                            backgroundColor: "#ffeaea",
                                            padding: "0.8rem",
                                            marginBottom: "0.5em",
                                            textAlign: "left",
                                            fontSize: "0.875rem",
                                        }}
                                    >
                                        <Typography variant="subtitle2">Rejected record(s) error(s):</Typography>
                                        {invalidRecords.map((records, recordIndex) => (
                                            <React.Fragment key={recordIndex}>
                                                {records.errors.map((error, errorIndex) => (
                                                    <Typography
                                                        key={`${recordIndex}-${errorIndex}`}
                                                        variant="body2"
                                                        gutterBottom
                                                        display="block"
                                                    >{`Row ${records?.row} - ${error}`}</Typography>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                    </Container>
                                </Box>
                            )}
                        {/* BCM-234: side-by-side Master Data + Storage Location
                            file pickers. A chosen file turns its card green with
                            a check, size and Remove link. */}
                        <Box className={classes.fileGrid}>
                            <Box
                                className={`${classes.fileCard} ${file ? classes.fileCardFilled : ''} ${slocFile ? classes.fileCardDisabled : ''}`}
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                            >
                                <input
                                    type="file"
                                    hidden
                                    ref={fileInputRef}
                                    onChange={handleFileChange}
                                    accept={getAcceptAttribute(fileType)}
                                />
                                <Typography className={classes.fileCardTitle}>
                                    Master Data File
                                </Typography>
                                {file ? (
                                    <Box className={classes.chosenRow}>
                                        <span className={classes.chosenCheck}>✓</span>
                                        <span className={classes.chosenName} title={file.name}>
                                            {file.name}
                                        </span>
                                        <span className={classes.chosenSize}>
                                            ({(file.size / (1024 * 1024)).toFixed(2)} MB)
                                        </span>
                                        <button
                                            type="button"
                                            className={classes.removeLink}
                                            onClick={handleRemoveFile}
                                            disabled={isUploading}
                                        >
                                            Remove
                                        </button>
                                    </Box>
                                ) : (
                                    <>
                                        <Button
                                            variant="outlined"
                                            className={classes.chooseFileBtn}
                                            onClick={() => fileInputRef.current && fileInputRef.current.click()}
                                            disabled={isUploading || Boolean(slocFile)}
                                        >
                                            Choose File
                                        </Button>
                                        {slocFile ? (
                                            <Typography className={classes.fileCardHint}>
                                                Only one file can be uploaded at a time
                                            </Typography>
                                        ) : null}
                                    </>
                                )}
                            </Box>

                            <Box
                                className={`${classes.fileCard} ${slocFile ? classes.fileCardFilled : ''} ${file ? classes.fileCardDisabled : ''}`}
                            >
                                <input
                                    type="file"
                                    hidden
                                    ref={slocInputRef}
                                    onChange={handleSlocFileChange}
                                    accept={getAcceptAttribute(fileType)}
                                />
                                <Typography className={classes.fileCardTitle}>
                                    Storage Location File
                                </Typography>
                                {slocFile ? (
                                    <Box className={classes.chosenRow}>
                                        <span className={classes.chosenCheck}>✓</span>
                                        <span className={classes.chosenName} title={slocFile.name}>
                                            {slocFile.name}
                                        </span>
                                        <span className={classes.chosenSize}>
                                            ({(slocFile.size / (1024 * 1024)).toFixed(2)} MB)
                                        </span>
                                        <button
                                            type="button"
                                            className={classes.removeLink}
                                            onClick={handleRemoveSlocFile}
                                            disabled={isUploading}
                                        >
                                            Remove
                                        </button>
                                    </Box>
                                ) : (
                                    <>
                                        <Button
                                            variant="outlined"
                                            className={classes.chooseFileBtn}
                                            onClick={() => slocInputRef.current && slocInputRef.current.click()}
                                            disabled={isUploading || Boolean(file)}
                                        >
                                            Choose File
                                        </Button>
                                        {file ? (
                                            <Typography className={classes.fileCardHint}>
                                                Only one file can be uploaded at a time
                                            </Typography>
                                        ) : null}
                                    </>
                                )}
                            </Box>
                        </Box>

                        <Box style={{ width: '100%' }}>
                            <Typography className={classes.criteriaTitle}>
                                Validation criteria
                            </Typography>
                            <Typography className={classes.criteriaLine}>
                                Upload one file at a time — either the Master Data File or the Storage Location File
                            </Typography>
                            <Typography className={classes.criteriaLine}>
                                Only excel files accepted (.xls, or .xlsx)
                            </Typography>
                            <Typography className={classes.criteriaLine}>
                                First row must contain headers only
                            </Typography>
                            <Typography className={classes.criteriaLine}>
                                File should not contain blank rows or columns
                            </Typography>
                        </Box>

                        <Box style={{ width: '100%', textAlign: 'center' }}>
                            <Button
                                variant="contained"
                                className={classes.uploadBtn}
                                endIcon={<ChevronRightIcon />}
                                onClick={handleUpload}
                                disabled={(!file && !slocFile) || isUploading || hasUploadedSuccessfully || invalidRecords.length > 0}
                            >
                                {isUploading ? 'Uploading...' : 'Upload'}
                            </Button>
                        </Box>
                    </Container>
                );
            case 1: {
                // BCM-234: totals span BOTH pipelines — Master Data (validationData)
                // and Storage Location (slocValidation) — so the summary reflects
                // everything the user is about to submit.
                const masterValidCount = validationData?.validRecordsCount || 0;
                const masterInvalidCount = validationData?.invalidRecordsCount || 0;
                const slocValidCount = slocValidation?.validRecordsCount || 0;
                const slocInvalidCount = slocValidation?.invalidRecordsCount || 0;
                const totalValid = masterValidCount + slocValidCount;
                const totalInvalid = masterInvalidCount + slocInvalidCount;
                const totalRecords = totalValid + totalInvalid;
                // SLoc invalids carry a single `error` string (no row/errors[]),
                // unlike Master Data invalids ({ row, errors[] }).
                const slocInvalidRecords = slocValidation?.invalidRecords || [];
                return (
                    <Container className={classes.container}>
                        <Typography variant="h5" style={{ marginBottom: "1em" }}>
                            Validation Summary
                        </Typography>

                        {/* Summary of Records */}
                        <Grid container spacing={3} justify="space-between">
                            {[
                                {
                                    label: "Total Records",
                                    value: totalRecords,
                                    className: classes.totalRecordsBox,
                                },
                                {
                                    label: "Valid Records",
                                    value: totalValid,
                                    className: classes.validRecordsBox,
                                },
                                {
                                    label: "Rejected Records",
                                    value: totalInvalid,
                                    className: classes.invalidRecordsBox,
                                },
                            ].map(({ label, value, className }, index) => (
                                <Grid item xs={12} sm={3} key={index}>
                                    <Box className={className}>
                                        <Typography>{label}</Typography>
                                        <Typography className={classes.number}>{value}</Typography>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>

                        {/* Rejected Records — Master Data ({ row, errors[] }) */}
                        {invalidRecords.length > 0 && (
                            <Grid item xs={12}>
                                <Box width="100%" style={{ margin: "1em 0" }}>
                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography variant="subtitle2">Master Data — rejected record(s) error(s)</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flexStart",
                                                textAlign: "left",
                                            }}
                                        >
                                            {invalidRecords.map((records, recordIndex) => (
                                                <React.Fragment key={recordIndex}>
                                                    {records.errors.map((error, errorIndex) => (
                                                        <Typography
                                                            key={`${recordIndex}-${errorIndex}`}
                                                            variant="body1"
                                                            gutterBottom
                                                            display="block"
                                                        >{`Row ${records?.row} - ${error}`}</Typography>
                                                    ))}
                                                    <br />
                                                </React.Fragment>
                                            ))}
                                        </AccordionDetails>
                                    </Accordion>
                                </Box>
                            </Grid>
                        )}

                        {/* Rejected Records — Storage Location (single `error` string per row) */}
                        {slocInvalidRecords.length > 0 && (
                            <Grid item xs={12}>
                                <Box width="100%" style={{ margin: "1em 0" }}>
                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography variant="subtitle2">Storage Location — rejected record(s) error(s)</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flexStart",
                                                textAlign: "left",
                                            }}
                                        >
                                            {slocInvalidRecords.map((record, recordIndex) => (
                                                <Typography
                                                    key={recordIndex}
                                                    variant="body1"
                                                    gutterBottom
                                                    display="block"
                                                >
                                                    {`${[
                                                        record["CMO ID in BMS SAP System"],
                                                        record["BMS Product Code"],
                                                        record["BMS Product Receiving Plant IDs"],
                                                        record["Storage Locations"],
                                                    ].filter((v) => v !== undefined && v !== null && String(v).trim() !== "").join(" / ")} — ${record.error}`}
                                                </Typography>
                                            ))}
                                        </AccordionDetails>
                                    </Accordion>
                                </Box>
                            </Grid>
                        )}

                        <Box className={classes.buttonContainer}>
                            <Button className={classes.reUploadButton} onClick={handleBack}>
                                &lt; Re-upload File
                            </Button>
                            <Box style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    variant="contained"
                                    className={classes.uploadButtonStyle}
                                    onClick={handleSubmitValidRecords}
                                    disabled={isSubmitting || totalValid === 0}
                                >
                                    {isSubmitting ? 'Submitting...' : 'Submit Records'}
                                    <ChevronRightIcon />
                                </Button>
                            </Box>
                        </Box>
                    </Container>
                );
            }
            default:
                return <Typography>Unknown Step</Typography>;
        }
    };

    return (
        <Box className={classes.root}>
            <Box className={classes.stepperHeader}>
                <Typography className={classes.heading}>
                    Upload Product Details
                </Typography>
                <Typography className={classes.subheading}>
                    Add / Update the list of products through the file
                </Typography>
                <Box className={classes.closePageAction} onClick={handleGoBack}>
                    <Typography style={{ fontWeight: 'bold', fontSize: "18px" }}>Cancel</Typography>
                    <CloseIcon />
                </Box>
            </Box>

            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            {getStepContent(activeStep)}

            {/* Success Dialog */}
            <UploadDetailsSavedDialog
                open={uploadSuccess}
                onClose={handleCloseDialog}
            />


        </Box>
    );
};

export default UploadProductDetails;